const {
  i18n: { __ },
  components: { PanelBody, TextControl },
} = wp;

const Label = ({ label, setAttributes }) => {
  return (
    <PanelBody title={__('Editor Control', 'b3rg')} initialOpen={true}>
      <TextControl
        className={'ec-label'}
        label={__('Label', 'b3rg')}
        defaultValue={label}
        onChange={(newValue) => {
          setAttributes({ label: newValue });
        }}
        max={25}
      />
    </PanelBody>
  );
};

export default Label;
